import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { TenantFindDto, type TenantFindInterface } from '@zaoblako/shared/modules/saas/dtos/tenant-find.dto';
import { TaskStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/task.status.type.enum';
import { TaskStatusFormSettingsDto, type TaskStatusFormSettingsInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-form-settings.dto';
import { TaskStatusTransitionFindDto, type TaskStatusTransitionFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-transition-find.dto';

import * as yup from 'yup';

export interface TaskStatusFindInterface {
  id: number;
  name: string;
  description: string;
  color: string;
  order: number;
  send: boolean;
  type: TaskStatusTypeEnum;
  auditors: UserFindInterface[];
  parent: TaskStatusFindInterface;
  tenant?: TenantFindInterface;
  children: TaskStatusFindInterface[];
  canSwitchTo: TaskStatusTransitionFindInterface[];
  formSettings: TaskStatusFormSettingsInterface;
}

export const TaskStatusFindDto = SerdeDtoClass.create<TaskStatusFindInterface>(TaskDtoKeysEnum.TASKS_STATUS_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
  description: {
    label: 'Описание',
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет',
    serializer: yup.string(),
  },
  order: {
    sortable: true,
    label: 'Сортировка',
    serializer: yup.number(),
  },
  send: {
    label: 'Отправлен',
    serializer: yup.boolean(),
  },
  type: {
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(Object.values(TaskStatusTypeEnum)),
  },
  auditors: {
    label: 'Аудиторы',
    nested: UserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  parent: {
    label: 'Аудиторы',
    nested: TaskDtoKeysEnum.TASKS_STATUS_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  tenant: {
    optional: true,
    label: 'Тенант',
    nested: TenantFindDto,
    serializer: (_, nested) => nested,
  },
  children: {
    label: 'Аудиторы',
    nested: TaskDtoKeysEnum.TASKS_STATUS_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
  canSwitchTo: {
    label: 'Доступные статусы для переключения',
    nested: TaskStatusTransitionFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  formSettings: {
    label: 'Настройки формы',
    nested: TaskStatusFormSettingsDto,
    serializer: (_, nested) => nested,
  },
});
